import { defineMessages } from 'react-intl';

export const fullName = defineMessages({
  additionalHandling: {
    description: 'otherShippingOptions.fullName.additionalHandling',
    defaultMessage: 'This shipment requires Additional Handling',
    id: 'NKIfF0',
  },
  alcohol: {
    description: 'otherShippingOptions.fullName.alcohol',
    defaultMessage: 'This shipment includes alcohol',
    id: 'OMQVfq',
  },
  b13ACanada: {
    description: 'otherShippingOptions.fullName.b13ACanada',
    defaultMessage: 'This shipment requires B13A export declaration',
    id: '3VqMhG',
  },
  consequentialLoss: {
    description: 'otherShippingOptions.fullName.consequentialLoss',
    defaultMessage: 'Consequential Loss',
    id: 'aPbUF5',
  },
  dangerousGoods: {
    description: 'otherShippingOptions.fullName.dangerousGoods',
    defaultMessage: 'This shipment contains dangerous goods',
    id: 'ZCxGfv',
  },
  dangerousGoodsLegacy: {
    description: 'The label for the checkbox that indicates that the shipment contains dangerous goods',
    defaultMessage: 'This shipment contains dangerous goods',
    id: '8rngk3',
  },
  dangerousGoodsSimple: {
    description: 'The label for the checkbox that indicates that the shipment contains dangerous goods',
    defaultMessage: 'This shipment contains dangerous goods',
    id: '8rngk3',
  },
  dangerousGoodsDhlEcommerceFullName: {
    description: 'otherShippingOptions.fullName.dangerousGoodsDhlEcommerce',
    defaultMessage: 'This shipment contains dangerous goods',
    id: 'cuRiao',
  },
  ancillaryEndorsementFullName: {
    description: 'otherShippingOptions > fullName > Ancillary Endorsement FullName',
    defaultMessage: 'This shipment has an Ancillary Endorsement',
    id: 'PKkPR0',
  },
  dangerousGoodsPurolator: {
    description: 'otherShippingOptions.fullName.dangerousGoodsPurolator',
    defaultMessage: 'This shipment contains dangerous goods',
    id: 'Gz1IAk',
  },
  freightClass: {
    description: 'otherShippingOptions.fullName.freightClassCode',
    defaultMessage: 'This shipment requires a Freight Classification code',
    id: 'BDZg54',
  },
  nonMachineable: {
    description: 'otherShippingOptions.fullName.nonMachinable',
    defaultMessage: 'This shipment is non-machinable',
    id: 'johFFs',
  },
  billToAccount: {
    description: 'otherShippingOptions.fullName.billToAccount',
    defaultMessage: 'Change Billing',
    id: 'epujeN',
  },
  billToSender: {
    description: 'otherShippingOptions.fullName.billToSender',
    defaultMessage: 'Bill duties and taxes to payor of shipping charges',
    id: '6qLHv8',
  },
  dontPrepayPostage: {
    description: 'otherShippingOptions.fullName.dontPrepayPostage',
    defaultMessage: 'Do not prepay postage for this shipment',
    id: 'yeP5s8',
  },
  dryIce: {
    description: 'otherShippingOptions.fullName.dryIce',
    defaultMessage: 'This shipment includes Dry Ice',
    id: '/Ds1w5',
  },
  includeReturnLabel: {
    description: 'otherShippingOptions.fullName.includeReturnLabel',
    defaultMessage: 'Include a return label with the outgoing shipping label',
    id: 'HErrNa',
  },
  printPostage: {
    description: 'otherShippingOptions.fullName.printPostage',
    defaultMessage: 'Print postage on the shipping label for this shipment',
    id: 'EG6r95',
  },
  specialHandling: {
    description: 'otherShippingOptions.fullName.specialHandling',
    defaultMessage: 'Special Handling (For whole shipment)',
    id: 'QYuEao',
  },
  collectOnDelivery: {
    description: 'otherShippingOptions.fullName.collectOnDelivery',
    defaultMessage: 'Collect payment on delivery (C.O.D.)',
    id: 'wR0H2A',
  },
  collectOnDeliverySimple: {
    description: 'otherShippingOptions.fullName.collectOnDeliverySimple',
    defaultMessage: 'Collect payment on delivery (C.O.D.)',
    id: 'qcu52b',
  },
  holdForPickup: {
    description: 'otherShippingOptions.fullName.holdForPickup',
    defaultMessage: 'Hold for Pickup',
    id: '2E2HgE',
  },
  localCollect: {
    description: 'otherShippingOptions.fullName.localCollect',
    defaultMessage: 'Local Collect',
    id: 'dvnJw2',
  },
  safeplace: {
    description: 'otherShippingOptions.fullName.safeplace',
    defaultMessage: 'Safeplace',
    id: '31g/n5',
  },
  saturdayDelivery: {
    description: 'otherShippingOptions.fullName.saturdayDelivery',
    defaultMessage: 'Saturday Delivery',
    id: 'KpD/Tt',
  },
  saturdayGuarantee: {
    description: 'otherShippingOptions.fullName.saturdayGuarantee',
    defaultMessage: 'Saturday Guarantee',
    id: 'Q+fmY3',
  },
  shipperRelease: {
    description: 'otherShippingOptions.fullName.shipperRelease',
    defaultMessage: 'Driver may release package without signature',
    id: 'FWoBTj',
  },
  thirdPartyConsignee: {
    description: 'otherShippingOptions.fullName.thirdPartyConsignee',
    defaultMessage: 'Third Party Consignee',
    id: '7wO9iJ',
  },
  emailNotification: {
    description: 'otherShippingOptions.fullName.emailNotification',
    defaultMessage: 'Email Notification',
    id: 'Xt8dXd',
  },
  smsNotification: {
    description: 'otherShippingOptions.fullName.smsNotification',
    defaultMessage: 'SMS Notification',
    id: '/ZSyML',
  },
  doNotNotifyMarketplace: {
    description: 'otherShippingOptions.fullName.doNotNotifyMarketplace',
    defaultMessage: 'Do not notify marketplace',
    id: '1XRhex',
  },
  blockAmazonLogistics: {
    description: 'Additional option for telling FBA to use a non-amazon carrier when shipping the order',
    defaultMessage: 'Block Amazon Logistics',
    id: 'wSeCad',
  },
  useBlankBox: {
    description: 'Additional option for telling FBA to use a non-amazon carrier when shipping the order',
    defaultMessage: 'Use Blank Box',
    id: '5f9CH4',
  },
  goGreenPlus: {
    description: 'GoGreen Plus enables carbon emissions reduction',
    defaultMessage: 'GoGreen Plus',
    id: 'DXnMVg',
  },
  regulatedContentType: {
    description: 'The full name for the drop down to select Regulated Content Type for a shipment',
    defaultMessage: 'Regulated Content Type',
    id: 'BsG76W',
  },
  movementIndicator: {
    description: 'Windsor Framework Movement Indicator label in other shipping options section',
    defaultMessage: 'Movement Indicator',
    id: '5Qvp2N',
  },
  serviceLevel: {
    description: 'Service Level abbreviated label in other shipping options',
    defaultMessage: 'Service Level',
    id: 'tNTJnh',
  },
  notAtRisk: {
    description: 'Windsor Framework Not at Risk label in other shipping options section',
    defaultMessage: 'Not at Risk',
    id: '5ahs3z',
  },
  fedExShipperLoadAndCount: {
    description: 'Fedex shipper load and count',
    defaultMessage: 'Shipper load and count',
    id: 'ay/ipX',
  },
  fedExBookingConfirmation: {
    description: 'Fedex booking confirmation',
    defaultMessage: 'Booking confirmation number',
    id: '1u44vQ',
  },
  exportLicenceRequired: {
    description: 'Royal Mail Export Licence Required full label in other shipping options',
    defaultMessage: 'Export Licence Required',
    id: 'Z5vmMX',
  },
  fragile: {
    description: 'otherShippingOptions.fullName.fragile',
    defaultMessage: 'This shipment is fragile',
    id: 'Rq2iqF',
  },
  deliveryAsAddressed: {
    description: 'otherShippingOptions.fullName.deliveryAsAddressed',
    defaultMessage: 'Delivery as addressed',
    id: '4nIMma',
  },
  returnAfterFirstAttempt: {
    description: 'otherShippingOptions.fullName.returnAfterFirstAttempt',
    defaultMessage: 'Return after first attempt',
    id: 'nj2wtT',
  },
  certificateOfOrigin: {
    description: 'otherShippingOptions.fullName.certificateOfOrigin',
    defaultMessage: 'Certificate of Origin',
    id: 'IVx3kT',
  },
});

export const abbreviated = defineMessages({
  additionalHandling: {
    description: 'otherShippingOptions.abbreviated.additionalHandling',
    defaultMessage: "Req. add'l handling",
    id: '99U+Wh',
  },
  alcohol: {
    description: 'otherShippingOptions.abbreviated.alcohol',
    defaultMessage: 'Contains alcohol',
    id: 'TDR4up',
  },
  b13ACanada: {
    description: 'otherShippingOptions.abbreviated.b13ACanada',
    defaultMessage: 'Req. B13A declaration',
    id: 'nzlxTb',
  },
  consequentialLoss: {
    description: 'otherShippingOptions.abbreviated.consequentialLoss',
    defaultMessage: 'Consequential Loss',
    id: 'XyPgzv',
  },
  dangerousGoods: {
    description: 'otherShippingOptions.abbreviated.dangerousGoods',
    defaultMessage: 'Dangerous Goods',
    id: 'nsSXzz',
  },
  dangerousGoodsLegacy: {
    description: 'The short label for the checkbox that indicates that the shipment contains dangerous goods',
    defaultMessage: 'Dangerous Goods',
    id: 'wF6T9+',
  },
  dangerousGoodsSimple: {
    description: 'The short label for the checkbox that indicates that the shipment contains dangerous goods',
    defaultMessage: 'Dangerous Goods',
    id: 'wF6T9+',
  },
  dangerousGoodsDhlEcommerceAbbreviated: {
    description: 'otherShippingOptions.abbreviated.dangerousGoodsDhlEcommerce',
    defaultMessage: 'Dangerous Goods',
    id: 'GGgthT',
  },
  ancillaryEndorsementAbbreviated: {
    description: 'otherShippingOptions > fullName > Ancillary Endorsement Abbreviated',
    defaultMessage: 'Ancillary Endorsement',
    id: 'vZXCrv',
  },
  dangerousGoodsPurolator: {
    description: 'otherShippingOptions.abbreviated.dangerousGoodsPurolator',
    defaultMessage: 'Dangerous Goods',
    id: 'bXJP3B',
  },
  freightClass: {
    description: 'otherShippingOptions.abbreviated.freightClassCode',
    defaultMessage: 'Req. freight code',
    id: 'YserPj',
  },
  nonMachineable: {
    description: 'otherShippingOptions.abbreviated.nonMachinable',
    defaultMessage: 'Non-machinable',
    id: 'lyEhGP',
  },
  billToAccount: {
    description: 'otherShippingOptions.abbreviated.billToAccount',
    defaultMessage: 'Change Billing',
    id: '2+TRmz',
  },
  billToSender: {
    description: 'otherShippingOptions.abbreviated.billToSender',
    defaultMessage: 'Bill to payor',
    id: 'VPHghf',
  },
  dontPrepayPostage: {
    description: 'otherShippingOptions.abbreviated.dontPrepayPostage',
    defaultMessage: 'Do not prepay postage',
    id: 'z39pPE',
  },
  dryIce: {
    description: 'otherShippingOptions.abbreviated.dryIce',
    defaultMessage: 'Dry Ice',
    id: 'g8rlkV',
  },
  includeReturnLabel: {
    description: 'otherShippingOptions.abbreviated.includeReturnLabel',
    defaultMessage: 'Include return label',
    id: 'Wu3CF7',
  },
  printPostage: {
    description: 'otherShippingOptions.abbreviated.printPostage',
    defaultMessage: 'Print postage on label',
    id: 'LWVqif',
  },
  specialHandling: {
    description: 'otherShippingOptions.abbreviated.specialHandling',
    defaultMessage: 'Special Handling',
    id: 'tDECka',
  },
  collectOnDelivery: {
    description: 'otherShippingOptions.abbreviated.collectOnDelivery',
    defaultMessage: 'C.O.D.',
    id: 'p3Gjx0',
  },
  collectOnDeliverySimple: {
    description: 'otherShippingOptions.abbreviated.collectOnDeliverySimple',
    defaultMessage: 'C.O.D.',
    id: 'ZPF4wC',
  },
  holdForPickup: {
    description: 'otherShippingOptions.abbreviated.holdForPickup',
    defaultMessage: 'Hold for Pickup',
    id: 'RdqQ1e',
  },
  localCollect: {
    description: 'otherShippingOptions.abbreviated.localCollect',
    defaultMessage: 'Local Collect',
    id: '/jR56f',
  },
  safeplace: {
    description: 'otherShippingOptions.abbreviated.safeplace',
    defaultMessage: 'Safeplace',
    id: 'XmGd4d',
  },
  saturdayDelivery: {
    description: 'otherShippingOptions.abbreviated.saturdayDelivery',
    defaultMessage: 'Saturday Delivery',
    id: 'emSDL/',
  },
  saturdayGuarantee: {
    description: 'otherShippingOptions.abbreviated.saturdayGuarantee',
    defaultMessage: 'Saturday Guarantee',
    id: 'KaWkv/',
  },
  shipperRelease: {
    description: 'otherShippingOptions.abbreviated.shipperRelease',
    defaultMessage: 'Release w/o signature',
    id: 'sJoxd+',
  },
  thirdPartyConsignee: {
    description: 'otherShippingOptions.abbreviated.thirdPartyConsignee',
    defaultMessage: 'Third Party Consignee',
    id: '19+hXX',
  },
  emailNotification: {
    description: 'otherShippingOptions.abbreviated.emailNotification',
    defaultMessage: 'Email Notification',
    id: 'CTWpOr',
  },
  smsNotification: {
    description: 'otherShippingOptions.abbreviated.smsNotification',
    defaultMessage: 'SMS Notification',
    id: 'QLFrxv',
  },
  doNotNotifyMarketplace: {
    description: 'otherShippingOptions.abbreviated.doNotNotifyMarketplace',
    defaultMessage: 'Do not notify marketplace',
    id: 'aSvTMC',
  },
  blockAmazonLogistics: {
    description: 'Additional option for telling FBA to use a non-amazon carrier when shipping the order',
    defaultMessage: 'Block Amazon Logistics',
    id: 'wSeCad',
  },
  useBlankBox: {
    description: 'Additional option for telling FBA to use a blank box when shipping the order',
    defaultMessage: 'Use Blank Box',
    id: '7ZTHXM',
  },
  goGreenPlus: {
    description: 'otherShippingOptions.abbreviated.goGreenPlus',
    defaultMessage: 'GoGreen Plus',
    id: 'DfSCGg',
  },
  regulatedContentType: {
    description: 'The short label for the drop down to select Regulated Content Type for a shipment',
    defaultMessage: 'Regulated Content',
    id: '6IKFRZ',
  },
  movementIndicator: {
    description: 'Movement Indicator abbreviated label in other shipping options',
    defaultMessage: 'Movement Indicator',
    id: '6gZccM',
  },
  serviceLevel: {
    description: 'Service Level abbreviated label in other shipping options',
    defaultMessage: 'Service Level',
    id: 'tNTJnh',
  },
  notAtRisk: {
    description: 'Not At Risk abbreviated label in other shipping options',
    defaultMessage: 'Not at Risk',
    id: '3znTYx',
  },
  fedExShipperLoadAndCount: {
    description: 'Fedex shipper load and count',
    defaultMessage: 'Shipper load and count',
    id: 'ay/ipX',
  },
  fedExBookingConfirmation: {
    description: 'Fedex booking confirmation',
    defaultMessage: 'Booking confirmation number',
    id: '1u44vQ',
  },
  exportLicenceRequired: {
    description: 'Royal Mail Export Licence Required abbreviated label in other shipping options',
    defaultMessage: 'Export Licence Required',
    id: 'tQVL61',
  },
  fragile: {
    description: 'otherShippingOptions.abbreviated.fragile',
    defaultMessage: 'Fragile',
    id: 'Eq/uid',
  },
  deliveryAsAddressed: {
    description: 'otherShippingOptions.abbreviated.deliveryAsAddressed',
    defaultMessage: 'Delivery as addressed',
    id: 'v6xP4X',
  },
  returnAfterFirstAttempt: {
    description: 'otherShippingOptions.abbreviated.returnAfterFirstAttempt',
    defaultMessage: 'Return after first attempt',
    id: 'RB1GpA',
  },
  certificateOfOrigin: {
    description: 'otherShippingOptions.abbreviated.certificateOfOrigin',
    defaultMessage: 'Certificate of Origin',
    id: '3eLQLM',
  },
});

export const tooltip = defineMessages({
  blockAmazonLogistics: {
    description: 'Tooltip indicating that Block Amazon Logistics will result in a fee from Amazon',
    defaultMessage: 'Checking this box will result in a 5% fee charged by Amazon',
    id: 'TuyXL0',
  },
  certificateOfOrigin: {
    description: 'Tooltip indicating that requesting a Certificate of Origin may incur a carrier fee',
    defaultMessage: 'The carrier may charge an additional fee to generate this document',
    id: 'ZrJuJA',
  },
});
